import React from 'react';

const ModalDownloadAssociateUsers = props => {
  return (
    <div
      data-close="ok"
      onClick={props.handleModal}
      className={props.modal ? `container-modal` : `container-modal hide`}
    >
      <section className="module-title modal-title">
        <h2>{props.language.account.modalDriver.howCreatedExcelAssociateUsers}</h2>
        <a>
          <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
        </a>
        {
          (props.statusFile && props.statusFile !== 200) && (
            <p className="error mb-2">{props.language.error[props.datosFile.error.messageCode]}</p>
          )
        }
      </section>
      {
        !props.statusFile && (
          <div className="box-form islabel center modal-button-box">
            <div>
              <input
                onClick={props.handleDownload}
                className="active"
                type="button"
                value={props.language.account.modalDriver.buttonDownload}
              />
            </div>
          </div>
        )
      }
    </div>
  )
};

export default ModalDownloadAssociateUsers;



// WEBPACK FOOTER //
// ./source/client/components/account_user/modalDownloadAssociateUsers.jsx